import Cookie from './cookie'

const TokenKey = 'vue_admin_template_token'
const WechatUserKey = 'yes_audio_wechat_user'

export function getToken() {
  return Cookie.get(TokenKey)
}

export function setToken(token) {
  return Cookie.set(TokenKey, token)
}

export function removeToken() {
  return Cookie.remove(TokenKey)
}

export function getWechatUser() {
  const raw = localStorage.getItem(WechatUserKey)
  if (!raw) return null

  try {
    const user = JSON.parse(raw)
    if (user.expiresAt && Date.now() >= user.expiresAt) {
      removeWechatUser()
      return null
    }
    return user
  } catch (error) {
    removeWechatUser()
    return null
  }
}

export function setWechatUser(user) {
  const expiresIn = Number(user.expiresIn || 86400)
  const payload = {
    ...user,
    userId: user.openid,
    expiresAt: Date.now() + expiresIn * 1000
  }
  localStorage.setItem(WechatUserKey, JSON.stringify(payload))
  if (payload.token) {
    setToken(payload.token)
  }
  return payload
}

export function removeWechatUser() {
  localStorage.removeItem(WechatUserKey)
  removeToken()
}



// WEBPACK FOOTER //
// ./src/utils/auth.js